export default "__VITE_ASSET__e85055c6__"